<template>
  <router-view />
  <alert-component />
  <cellphone-component />
</template>

<script>
import alertComponent from "./components/Alert/alertComponent.vue";
import cellphoneComponent from "./components/autentification/cellphoneComponent.vue";
export default {
  components: { alertComponent, cellphoneComponent },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    setStorage() {
      if (this.nameRoute !== "Purchase") {
        this.$store.state.cuponStatu = null;
        this.$store.state.cuponCode = "";
        this.$store.state.cuponMonto = null;
        this.$store.state.cuponMontoSoles = null;
        this.$store.state.saldoStatu = false;
        this.$store.state.saldoMonto = 0.0;
        this.$store.state.saldoMontoSoles = 0.0;
        this.$store.state.saldoTotalStatu = false;
        this.$store.commit("resetServicios");
        window.localStorage.removeItem("producto");
      }
    },
  },
  computed: {
    nameRoute() {
      return this.$route.name;
    },
  },
  watch: {
    nameRoute: function () {
      this.setStorage();
    },
  },
};
</script>
